"use strict";
//import {colorAccepted, colorDeclined} from '../styles/base';
// TODO: importing to this base constants file from another service seems unwise, but there are no
// current negative side effects since Resource is current just constants and has no dependencies.
// Eventually, we should consolidate the access roles into AccessControl (which should be moved
// from components into services)
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.PROPOSAL_STATUS_EXTENDED = exports.PROPOSAL_STATUS_DENIED = exports.PROPOSAL_STATUS_CLOSED = exports.PROPOSAL_STATUS_WITHDRAWN = exports.PROPOSAL_STATUS_ENDED = exports.PROPOSAL_STATUS_STARTED = exports.PROPOSAL_STATUS_ACCEPTED = exports.PROPOSAL_STATUS_SUBMITTED = exports.PROPOSAL_TYPE_CALL = exports.PROPOSAL_TYPE_STAFF_TIME = exports.PROPOSAL_TYPE_INTRAMURAL = exports.PROPOSAL_TYPE_LIMITED_SCOPE = exports.PROPOSAL_TYPE_PROPRIETARY_PUBLIC = exports.PROPOSAL_TYPE_PARTNER = exports.PROPOSAL_TYPE_RAPID = exports.PROPOSAL_TYPE_CAPACITY = exports.PROPOSAL_TYPE_PROPRIETARY = exports.PROPOSAL_TYPE_RESOURCE_OWNER = exports.PROPOSAL_TYPE_GENERAL = exports.SPECIAL_ACCESS_ROLES = exports.GENERIC_ACCESS_ROLES = exports.ROLE_EXPORT_CONTROL = exports.ROLE_COUNTER_INTELLIGENCE = exports.ROLE_AUTHORIZED_RESERVER = exports.ROLE_CUSTODIAN = exports.ROLE_SUPER = exports.ROLE_SOFTWARE = exports.ROLE_SERVICES = exports.ROLE_RISK = exports.ROLE_READONLY = exports.ROLE_HUMAN = exports.ROLE_GENERAL = exports.ROLE_GC = exports.ROLE_EQUIPMENT = exports.ROLE_BIOLOGICAL = exports.ROLE_RAD_ENGINEERING = exports.ROLE_PRODUCT_LINE = exports.ROLE_ANIMAL_CARE = exports.ROLE_ENVIRON = exports.ROLE_CAT = exports.ROLE_BUSINESS_NP = exports.ROLE_BUSINESS_P = exports.ROLE_ADMIN = exports.ROLE_NO_ACCESS = exports.TYPE_METABOLIC_PATHWAY = exports.TYPE_FUNCTIONAL_CATEGORY = exports.TYPE_METABOLITE = exports.TYPE_GENE = exports.colorDeclined = exports.colorAccepted = void 0;
exports.NEXUS_ROUTES = exports.getFirstMonthOfCurrentQuarter = exports.nextFy = exports.getCurrentFY = exports.getFyByDate = exports.WORKSPACE_ALLOWED_PROPOSAL_STATUSES = exports.ACTIVE_PROPOSAL_STATUSES = exports.ENDED_PROPOSAL_STATUSES = exports.REF_KEYCLOAK_REFRESH_TOKEN = exports.REF_KEYCLOAK_AUTH_TOKEN = exports.REF_IMPERSONATION_UUID = exports.REF_IMPERSONATION_USER_ID = exports.REF_CURRENT_USER = exports.REF_CURRENT_USER_ID = exports.DISPLAY_DATE_FORMAT = exports.RECURRENCE_END_YEAR = exports.RECURRENCE_END_AFTER = exports.RECURRENCE_END_ON = exports.RESOURCE_STATUS_TRANSLATION = exports.INACTIVE_RESOURCE_STATUSES = exports.ACTIVE_RESOURCE_STATUSES = exports.REVIEW_STATUS_TRANSLATION = exports.LOI_APPROVAL = exports.COUNTER_INTELLIGENCE = exports.EXPORT_CONTROL = exports.HAZARDS = exports.BIOLOGICAL = exports.RAD_ENGINEERING = exports.PL = exports.PEER_REVIEW = exports.HUMAN = exports.GC = exports.CAPABILITY_LEAD = exports.ESH = exports.BUSINESS_OFFICE = exports.ANIMAL_CARE = exports.EXTENSIONS = void 0;
exports.colorAccepted = '#D4EDD6';
exports.colorDeclined = '#fabcbc';
/**
 * Symbolic Constants
 */
exports.TYPE_GENE = 'Gene';
exports.TYPE_METABOLITE = 'Metabolite';
exports.TYPE_FUNCTIONAL_CATEGORY = 'Functional Category';
exports.TYPE_METABOLIC_PATHWAY = 'Metabolic Pathway';
/**
 * Staff Roles
 */
exports.ROLE_NO_ACCESS = 'no_access'; // No access
exports.ROLE_ADMIN = 'admin'; // Facility/Administration
exports.ROLE_BUSINESS_P = 'business_proprietary'; // Business Office Proprietary
exports.ROLE_BUSINESS_NP = 'business_non-proprietary'; // Business Office Non-Proprietary
exports.ROLE_CAT = 'cat'; // Collaborative Access Teams
exports.ROLE_ENVIRON = 'environment'; // Environment, Health, and Safety Office
exports.ROLE_ANIMAL_CARE = 'animal_care'; // Animal Care
exports.ROLE_PRODUCT_LINE = 'product_line'; // Project Management Office
exports.ROLE_RAD_ENGINEERING = 'rad_engineering'; // Radiological Engineering
exports.ROLE_BIOLOGICAL = 'biological'; // Biological
exports.ROLE_EQUIPMENT = 'equipment'; // Equipment Maintenance
exports.ROLE_GC = 'gc'; // Grand Challenge
exports.ROLE_GENERAL = 'general'; // General EMSL
exports.ROLE_HUMAN = 'human'; // Human Studies Office
exports.ROLE_READONLY = 'read_only'; // Read Only
exports.ROLE_RISK = 'safety_and_health'; // Risks Office
exports.ROLE_SERVICES = 'services'; // User Services
exports.ROLE_SOFTWARE = 'software'; // Software Distribution
exports.ROLE_SUPER = 'super'; // Super User
exports.ROLE_CUSTODIAN = 'custodian'; // Resource Custodian (view generated roles from personnel)
exports.ROLE_AUTHORIZED_RESERVER = 'authorized_reserver';
exports.ROLE_COUNTER_INTELLIGENCE = 'counter_intelligence';
exports.ROLE_EXPORT_CONTROL = 'export_control';
exports.GENERIC_ACCESS_ROLES = 'access_role';
exports.SPECIAL_ACCESS_ROLES = 'approval_role';
/**
 * Proposal Types
 */
exports.PROPOSAL_TYPE_GENERAL = 'general';
exports.PROPOSAL_TYPE_RESOURCE_OWNER = 'resource_owner';
exports.PROPOSAL_TYPE_PROPRIETARY = 'proprietary';
exports.PROPOSAL_TYPE_CAPACITY = 'capacity';
exports.PROPOSAL_TYPE_RAPID = 'rapid';
exports.PROPOSAL_TYPE_PARTNER = 'partner';
exports.PROPOSAL_TYPE_PROPRIETARY_PUBLIC = 'proprietary_public';
exports.PROPOSAL_TYPE_LIMITED_SCOPE = 'limited_scope';
exports.PROPOSAL_TYPE_INTRAMURAL = 'intramural_s_t';
exports.PROPOSAL_TYPE_STAFF_TIME = 'staff_time';
exports.PROPOSAL_TYPE_CALL = 'call';
/**
 * Project Statuses
 */
exports.PROPOSAL_STATUS_SUBMITTED = 'submitted';
exports.PROPOSAL_STATUS_ACCEPTED = 'accepted';
exports.PROPOSAL_STATUS_STARTED = 'started';
exports.PROPOSAL_STATUS_ENDED = 'ended';
exports.PROPOSAL_STATUS_WITHDRAWN = 'withdrawn';
exports.PROPOSAL_STATUS_CLOSED = 'closed';
exports.PROPOSAL_STATUS_DENIED = 'denied';
exports.PROPOSAL_STATUS_EXTENDED = 'extended';
/**
 * Approval Types
 */
exports.EXTENSIONS = 'extensions';
exports.ANIMAL_CARE = 'animal_care';
exports.BUSINESS_OFFICE = 'business_office';
exports.ESH = 'esh';
exports.CAPABILITY_LEAD = 'facilities';
exports.GC = 'grand_challenge';
exports.HUMAN = 'human_study';
exports.PEER_REVIEW = 'review';
exports.PL = 'product_line';
exports.RAD_ENGINEERING = 'rad_engineering';
exports.BIOLOGICAL = 'biological';
exports.HAZARDS = 'hazards';
exports.EXPORT_CONTROL = 'export_control';
exports.COUNTER_INTELLIGENCE = 'counter_intelligence';
exports.LOI_APPROVAL = 'loi';
exports.REVIEW_STATUS_TRANSLATION = {
    accepted: { status_label: 'Accepted Review - Not Submitted', background: undefined },
    awaiting_response: { status_label: 'Awaiting Response', background: undefined },
    declined: { status_label: 'Declined Review', background: exports.colorDeclined },
    in_progress: { status_label: 'In Progress', background: undefined },
    submitted: { status_label: 'Submitted Review', background: exports.colorAccepted },
    closed: { status_label: 'Approval Closed Before Submission', background: undefined },
    completed: { status_label: 'Review Completed', background: exports.colorAccepted }
};
exports.ACTIVE_RESOURCE_STATUSES = [
    'Resource Operational',
    'Resource Transferred',
    'Resource Acquired'
];
exports.INACTIVE_RESOURCE_STATUSES = [
    'Resource Switched Off',
    'Resource Divested',
    'Resource Inoperative',
    'Resource Unavailable'
];
exports.RESOURCE_STATUS_TRANSLATION = __spreadArray(__spreadArray([], exports.ACTIVE_RESOURCE_STATUSES, true), exports.INACTIVE_RESOURCE_STATUSES, true);
/**
 * Reservation Types
 */
exports.RECURRENCE_END_ON = 'on';
exports.RECURRENCE_END_AFTER = 'after';
exports.RECURRENCE_END_YEAR = 'year';
exports.DISPLAY_DATE_FORMAT = 'MMMM DD, YYYY';
exports.REF_CURRENT_USER_ID = "current_user_id";
exports.REF_CURRENT_USER = "current_user";
exports.REF_IMPERSONATION_USER_ID = "impersonation_user_id";
exports.REF_IMPERSONATION_UUID = "impersonation_uuid";
exports.REF_KEYCLOAK_AUTH_TOKEN = "auth_token";
exports.REF_KEYCLOAK_REFRESH_TOKEN = "refresh_token";
exports.ENDED_PROPOSAL_STATUSES = [
    exports.PROPOSAL_STATUS_CLOSED,
    exports.PROPOSAL_STATUS_DENIED,
    exports.PROPOSAL_STATUS_WITHDRAWN,
];
/**
 * Statuses which are translated to 'Active' or 'Invited' in the UI (Per USO request in Nov 2020)
 * @type {string[]} - Proposal Statuses to translate.
 */
exports.ACTIVE_PROPOSAL_STATUSES = [
    exports.PROPOSAL_STATUS_STARTED,
    exports.PROPOSAL_STATUS_EXTENDED
];
/**
 * Statuses which are allowed to see the workspace tab
 * @type {string[]} - Proposal statuses that are allowed to see the workspace tab
 */
exports.WORKSPACE_ALLOWED_PROPOSAL_STATUSES = [
    exports.PROPOSAL_STATUS_STARTED,
    exports.PROPOSAL_STATUS_ACCEPTED,
    exports.PROPOSAL_STATUS_CLOSED,
    exports.PROPOSAL_STATUS_EXTENDED,
    exports.PROPOSAL_STATUS_SUBMITTED // 02/21/2023: Request from Rick to have workspaces open as soon as the proposal submitted
];
/**
 * Return the fiscal year as full year for provided date
 * @param {string|number|Date} date The date
 * @returns {number} The FY
 */
function getFyByDate(date) {
    var currentDate = new Date(date);
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth() + 1;
    // FY start in October
    return currentMonth > 9 ? currentYear + 1 : currentYear;
}
exports.getFyByDate = getFyByDate;
/**
 * Return the current fiscal year as full year
 */
var getCurrentFY = function () { return getFyByDate(new Date()); };
exports.getCurrentFY = getCurrentFY;
function nextFy() {
    return ((0, exports.getCurrentFY)() + 1);
}
exports.nextFy = nextFy;
/**
 * Return the numerical month that starts the current quarter
 * Moment is 0 indexed (yay!) for months, so we just need to follow the formula below
 */
function getFirstMonthOfCurrentQuarter() {
    return (Math.floor(new Date().getMonth() / 3) * 3);
}
exports.getFirstMonthOfCurrentQuarter = getFirstMonthOfCurrentQuarter;
exports.NEXUS_ROUTES = {
    PORTAL: {
        path: "/Portal",
        name: 'Portal'
    }
};
